var path = 'areas/shared/views/interrupt-fields/interrupt_Checkbox.html';
var html = "<div class=checkbox><label> <input type=checkbox ng-model=element.value ng-true-value=\"'True'\" ng-false-value=\"'False'\" ng-disabled=isDisabled ng-init='element.value = \"false\";'> {{ element.properties.Text }} </label></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/interrupt-fields/interrupt_Checkbox.html
// module id = 1153540662401820
// module chunks = 1